export default __webpack_public_path__ + "static/media/b_listening_large.3a670633.png";